import { RequestBase, ResponseBaseSet } from ".";
import { IAuthMenu } from "../future-deprecation/iauth-menu";

export class RequestMenu extends RequestBase {

  hierarchyId?: string;
  hierarchyCode?: string;
  authType?: string;
  moduleId?: string;
}

export class ResponseMenu extends ResponseBaseSet<IAuthMenu>{
}
